import * as React from "react";
import { ClipboardList, Presentation, GraduationCap, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "İlk Tanışma ve Muayene",
  description: "Çocuğunuzun kliniğimize alışması için oyun odaklı bir yaklaşım sergiliyor, diş gelişim sürecini detaylıca inceliyoruz.",
  icon: ClipboardList
}, {
  title: "Konforlu Tedavi Süreci",
  description: "Modern teknolojiler ve pedagojik yaklaşımlarla, minik hastalarımızın konforlu ve korkusuz şekilde tedavi edilmesini sağlıyoruz.",
  icon: Presentation
}, {
  title: "Sağlıklı Alışkanlıklar",
  description: "Doğru fırçalama teknikleri ve koruyucu uygulamalarla, ömür boyu sürecek bir ağız sağlığı ve hijyen bilincinin temelini atıyoruz.",
  icon: GraduationCap
}];
export default function TeachingProcessSteps() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="1137" id="çocuk-diş-tedavileri" ref={ref} className="relative py-24 text-foreground overflow-hidden bg-cover bg-center bg-no-repeat !bg-[url(https://dtaysegul.com/wp-content/uploads/2026/04/pedodonti-1-1.jpg)] bg-blend-overlay bg-background/90">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`mb-16 text-center transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl font-serif tracking-tight sm:text-5xl md:text-[48px] mb-4 text-foreground">
            Çocuk Diş Sağlığı Sürecimiz
          </h2>
          <p className="mx-auto max-w-2xl text-muted-foreground text-lg font-sans">
            Minik misafirlerimiz için korkusuz, eğlenceli ve profesyonel bir diş hekimliği deneyimi sunuyoruz.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3 relative">
          {}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-border -z-10" aria-hidden="true" />

          {steps.map((step, i) => {
          const Icon = step.icon;
          const delayClass = i === 0 ? "delay-100" : i === 1 ? "delay-200" : "delay-300";
          return <div key={i} data-index={i} className={`transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"} ${delayClass}`}>
                <Card className="h-full border-none shadow-none bg-transparent text-center relative group backdrop-blur-sm hover:bg-secondary/40 transition-colors duration-500 rounded-lg">
                  <CardHeader className="flex flex-col items-center pb-2 pt-0">
                    <div className="relative mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-background border-2 border-muted group-hover:border-primary/30 transition-colors duration-500 z-10 shadow-sm">
                      <div className="absolute inset-0 rounded-full bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                      <Icon className="h-10 w-10 text-primary stroke-[1px]" />
                      <div className="absolute -right-2 -top-2 flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground text-xs font-bold shadow-md">
                        {i + 1}
                      </div>
                    </div>
                    <CardTitle className="text-[14px] font-sans font-medium uppercase tracking-widest text-foreground">{step.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground font-sans">
                      {step.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className={`mt-16 text-center transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Button asChild size="lg" className="rounded-full px-8 bg-primary hover:bg-primary/90 text-primary-foreground font-sans tracking-wide transition-all shadow-lg">
            <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab>
              Randevu Alın <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}